module.exports = __webpack_public_path__ + "static/media/litter_icon.6c70aec3.svg";